module.exports = global.config = {
    context:false,
    sidebarFooter: false
};